import { queryOptions } from '@tanstack/react-query'

import {
  fetchContentLibraryCategory,
  fetchContentSession,
} from '../dal/contentful-library-dal'
import { queryKeys } from './query-keys'

export const libraryQueryOptions = (language: string) =>
  queryOptions({
    queryKey: queryKeys.library.all(language),
    queryFn: () => fetchContentLibraryCategory(language),
  })

export const sessionQueryOptions = (id: string, language: string) =>
  queryOptions({
    queryKey: queryKeys.sessions.byLocale(id, language),
    queryFn: () => fetchContentSession(id, language),
    staleTime: 5 * 60 * 1000,
  })

export type {
  ContentAsset,
  ContentSession,
} from '../dal/contentful-library-dal'
